import logo from 'assets/logo/sandvik_logo_white.svg'

export const SandvikLogo = ({ className = '' }) => <img className={`main-logo ${className}`} src={logo} />
